import LinearProgressWithLabel from 'Components/LinearProgressWithLabel'
import {
  type ReportGenerationStatusShape,
  WebsocketConnectionStatus
} from 'Services/SalesManagement/Features/Report/reportSlice'
import useTypedSelector, { useAppDispatch } from 'Store'
import { WEBSOCKET_CONNECTION_MAX_RETRIES } from 'Util/constants'
import WebsocketUrl from 'Util/WebsocketUrl'
import { connect, disconnect } from '@giantmachines/redux-websocket'
import { useEffect, useState } from 'react'

const getReportProgress = (reportStatus: ReportGenerationStatusShape | null) => {
  let progress = 0
  if (reportStatus?.info) {
    if (reportStatus.info.total === 0) {
      // There are no rows in the report when total is 0
      progress = 1
    } else {
      progress = reportStatus.info.current / reportStatus.info.total
    }
  }
  // Convert to percentages
  return progress * 100
}

interface ReportProgressProps {
  reportGenerationTask: { task_id: string } | null
  reportPrefix: string
  reportStatus: ReportGenerationStatusShape | null
  reportPath: string
  resetReportWebsocketState: () => void
}

export default function ReportProgress({
  reportGenerationTask,
  reportPrefix,
  reportStatus,
  reportPath,
  resetReportWebsocketState
}: Readonly<ReportProgressProps>) {
  const dispatch = useAppDispatch()

  const { websocketConnection, disconnectByError } = useTypedSelector(state => state.report)

  const [websocketConnectionRetryCount, setWebsocketConnectionRetryCount] = useState(0)

  useEffect(() => {
    if (reportGenerationTask) {
      switch (websocketConnection) {
        case WebsocketConnectionStatus.IDLE:
          connectWebsocket(reportGenerationTask.task_id)
          break
        case WebsocketConnectionStatus.CONNECTION_ERROR:
          connectWebsocket(reportGenerationTask.task_id)
          break
        case WebsocketConnectionStatus.ERROR:
          dispatch(disconnect(reportPrefix))
          resetReportWebsocketState()
          break
        case WebsocketConnectionStatus.CONNECTED:
          setWebsocketConnectionRetryCount(0)
          break
      }
    }
  }, [dispatch, reportGenerationTask, websocketConnection, disconnectByError])

  const connectWebsocket = (taskId: string) => {
    if (websocketConnectionRetryCount < WEBSOCKET_CONNECTION_MAX_RETRIES) {
      dispatch(connect(WebsocketUrl(`${reportPath}/${taskId}/`), reportPrefix))
      setWebsocketConnectionRetryCount(websocketConnectionRetryCount + 1)
    }
  }

  return (
    <>
      {reportGenerationTask && <LinearProgressWithLabel value={getReportProgress(reportStatus)} />}
    </>
  )
}
